module.exports = {

	methods: {

		createImage: function(returnFunction, errorFunction) {
		
	   		 // Make a snapshop of the picture wall 
		      var html2canvas = require('html2canvas');

		      	if($(window).width() < 960) {
			    	$("#pictureWall").addClass("2x")
				}

		      html2canvas($("#zoomElement"), {
		          //scale: 3,
		          proxy: 'https://' + window.location.hostname,
		          useCORS: true,
		          onrendered: function(canvas){
		          	  $("#pictureWall").removeClass("2x")
		              var formData = new FormData()
		              var value = canvas.toDataURL("image/jpeg");
		              formData.append('image', value)

		              $.ajax({
		                url: 'https://desenio-ecommerce.com/pictureWall/image', 
		                data: formData,                         
		                type: 'POST',
		                contentType: false,
		                processData: false,
		                dataType: 'json',
		                success: function(response){
		                
		                  // If everything went OK
		                  if(response.status){
		                    returnFunction(response);
		                    return true;
		                  }

		                  errorFunction(response);

		                }
		             });

		          }
		      });
		}
		
	}
	
};


// WEBPACK FOOTER //
// ./client/mixins/createImage.js